
const localStorage = window.localStorage;

/* ------------------------ AUTH (ADMIN) ------------------------ */

export const storeTokens = async (token, refreshToken) => {
  await localStorage.setItem("jwt", token);
  await localStorage.setItem("refresh", refreshToken);
};

export const clearTokens = async () => {
  await localStorage.removeItem("jwt");
  await localStorage.removeItem("refresh");
};

export const getToken = async () => {
  const value = await localStorage.getItem("jwt");
  return value;
};

export const getRefreshToken = async () => {
  const value = await localStorage.getItem("refresh");
  return value;
};
